import { computed } from 'vue'
import { useStore } from 'vuex'

export const useSortingItems = () => {
  const store = useStore()
  const hideOrders = computed(() => store.getters['shop/hideSales'])

  const sortingItems = computed(() => {
    const items = [
      { label: 'Date', value: 'date' },
      { label: 'Clicks', value: 'clicks' },
    ]

    if (!hideOrders.value) {
      items.push({ label: 'Order value', value: 'order_value' })
    }

    return items
  })

  return { sortingItems }
}
